import { useState } from "react";

import firebase from "firebase/compat/app";
import { storage, firestore, auth } from "../firebase";
import { useUserProvider } from "../context/UserProvider";
import { useParams, useHistory, Link } from "react-router-dom";

import { toast } from "react-toastify"; // then this

// import BeforeWorks from "./AddNewWallParts/BeforeWorks";
// import AfterWorks from "./AddNewWallParts/AfterWorks";

// Conditions 1
import BstkHorizontalWall from "./AddNewWallParts/BeforeWorks/StackedRooms/BstkHorizontalWall";
import BstkStackedRoom1 from "./AddNewWallParts/BeforeWorks/StackedRooms/BstkStackedRoom1";
import BstkStackedRoom2 from "./AddNewWallParts/BeforeWorks/StackedRooms/BstkStackedRoom2";
// Condition 2
import BsbsVerticalWall from "./AddNewWallParts/BeforeWorks/SideBySideRooms/BsbsVerticalWall";
import BsbsSideRoom1 from "./AddNewWallParts/BeforeWorks/SideBySideRooms/BsbsSideRoom1";
import BsbsSideRoom2 from "./AddNewWallParts/BeforeWorks/SideBySideRooms/BsbsSideRoom2";
// Condition 3
import AstkHorizontalWall from "./AddNewWallParts/AfterWorks/StackedRooms/AstkHorizontalWall";
import AstkStackedRoom1 from "./AddNewWallParts/AfterWorks/StackedRooms/AstkStackedRoom1";
import AstkStackedRoom2 from "./AddNewWallParts/AfterWorks/StackedRooms/AstkStackedRoom2";
// Condition 2
import AsbsVerticalWall from "./AddNewWallParts/AfterWorks/SideBySideRooms/AsbsVerticalWall";
import AsbsSideRoom1 from "./AddNewWallParts/AfterWorks/SideBySideRooms/AsbsSideRoom1";
import AsbsSideRoom2 from "./AddNewWallParts/AfterWorks/SideBySideRooms/AsbsSideRoom2";

import {
  Card,
  CardContent,
  Button,
  TextField,
  Stack,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  InputLabel,
  MenuItem,
  Grid,
  Typography,
} from "@mui/material";

export default function AddNewWall2(props) {
  const history = useHistory();
  const { user } = useUserProvider();
  const { uid, displayName, email, photoURL } = auth.currentUser || {};
  const { id } = useParams();

  const [page, setPage] = useState(0);
  // const [formData, setFormData] = useState({

  // });

  const [formData, setFormData] = useState({
    registrationPeriod: "",
    roomDisposalDependingBeforeWorks: "",
    roomDisposalDependingAfterWorks: "",
    // Horizontal Wall (After Works)
    horizontalWallOverlay: "",
    horizontalWallOverlayInterventions: "",
    horizontalWallCoating: "",
    horizontalWallCoatingInterventions: "",
    horizontalWallStructure: "",
    horizontalWallStructureInterventions: "",
    horizontalWallCeiling: "",
    horizontalWallCeilingInterventions: "",
    horizontalWallSurface: "",
    horizontalWallNotes: "",
    // Stacked Room 1 (After Works)
    stackedRoom1Name: "",
    stackedRoom1TypeOf: "",
    stackedRoom1Volume: "",
    stackedRoom1LateralWall1: "",
    stackedRoom1LateralWall2: "",
    stackedRoom1LateralWall3: "",
    stackedRoom1LateralWall4: "",
    stackedRoom1Notes: "",
    // Stacked Room 2 (After Works)
    stackedRoom2Name: "",
    stackedRoom2TypeOf: "",
    stackedRoom2Volume: "",
    stackedRoom2LateralWall1: "",
    stackedRoom2LateralWall2: "",
    stackedRoom2LateralWall3: "",
    stackedRoom2LateralWall4: "",
    stackedRoom2Notes: "",
    // Vertical Wall (After Works)
    verticalWallCoatingSideRoom1: "",
    verticalWallCoatingSideRoom1Interventions: "",
    verticalWallStructure: "",
    verticalWallStructureInterventions: "",
    verticalWallCoatingSideRoom2: "",
    verticalWallCoatingSideRoom2Interventions: "",
    verticalWallSurface: "",
    verticalWallNotes: "",
    // Side Room 1 (After Works)
    sideRoom1Name: "",
    sideRoom1TypeOf: "",
    sideRoom1Volume: "",
    sideRoom1LateralWall1: "",
    sideRoom1LateralWall2: "",
    sideRoom1Ceiling: "",
    sideRoom1CeilingStructure: "",
    sideRoom1FloorCoating: "",
    sideRoom1FloorStructure: "",
    sideRoom1Notes: "",
    // Side Room 2 (After Works)
    sideRoom2Name: "",
    sideRoom2TypeOf: "",
    sideRoom2Volume: "",
    sideRoom2LateralWall1: "",
    sideRoom2LateralWall2: "",
    sideRoom2Ceiling: "",
    sideRoom2CeilingStructure: "",
    sideRoom2FloorCoating: "",
    sideRoom2FloorStructure: "",
    sideRoom2Notes: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      formData.registrationPeriod === "Before Works" &&
      formData.roomDisposalDependingBeforeWorks === "Stacked Rooms" &&
      formData.stackedRoom1Name &&
      formData.stackedRoom2Name
    ) {
      const newWall1 = {
        formData,
        // formData1,
        user: {
          uid,
          displayName,
          email,
          photoURL,
        },
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      firestore
        .collection("sites")
        .doc(id)
        // .collection("walls/before works/stacked rooms")
        .collection("walls")
        .add(newWall1);

      setFormData("");
      // setFormData1("");

      history.push(`/sites/${id}/walls`);
      toast.success("Wall created successfully", {
        theme: "colored",
      });
    } else if (
      formData.registrationPeriod === "Before Works" &&
      formData.roomDisposalDependingBeforeWorks === "Side By Side Rooms" &&
      formData.sideRoom1Name &&
      formData.sideRoom2Name
    ) {
      const newWall2 = {
        formData,
        // formData2,
        user: {
          uid,
          displayName,
          email,
          photoURL,
        },
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      firestore
        .collection("sites")
        .doc(id)
        // .collection("walls/before works/side by side rooms")
        .collection("walls")
        .add(newWall2);

      setFormData("");
      // setFormData2("");

      history.push(`/sites/${id}/walls`);
      toast.success("Wall created successfully", {
        theme: "colored",
      });
    } else if (
      formData.registrationPeriod === "After Works" &&
      formData.roomDisposalDependingAfterWorks === "Stacked Rooms" &&
      formData.stackedRoom1Name &&
      formData.stackedRoom2Name
    ) {
      const newWall3 = {
        formData,
        // formData3,
        user: {
          uid,
          displayName,
          email,
          photoURL,
        },
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      firestore
        .collection("sites")
        .doc(id)
        // .collection("walls/after works/stacked rooms")
        .collection("walls")
        .add(newWall3);

      setFormData("");
      // setFormData3("");

      history.push(`/sites/${id}/walls`);
      toast.success("Wall created successfully", {
        theme: "colored",
      });
    } else if (
      formData.registrationPeriod === "After Works" &&
      formData.roomDisposalDependingAfterWorks === "Side By Side Rooms" &&
      formData.sideRoom1Name &&
      formData.sideRoom2Name
    ) {
      const newWall4 = {
        formData,
        // formData4,
        user: {
          uid,
          displayName,
          email,
          photoURL,
        },
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      firestore
        .collection("sites")
        .doc(id)
        // .collection("walls/after works/side by side rooms")
        .collection("walls")
        .add(newWall4);

      setFormData("");
      // setFormData4("");

      history.push(`/sites/${id}/walls`);
      toast.success("Wall created successfully", {
        theme: "colored",
      });
    } else {
      toast.error("Please, fill riquired fields", {
        theme: "colored",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h5">Registration period</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl>
                  {/* <FormLabel id="demo-radio-buttons-group-label">
                    Registration period
                  </FormLabel> */}

                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="registration period"
                    value={formData.registrationPeriod}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        registrationPeriod: e.target.value,
                      })
                    }
                  >
                    <FormControlLabel
                      value="Before Works"
                      control={<Radio />}
                      label="Before Works"
                    />
                    <FormControlLabel
                      value="After Works"
                      control={<Radio />}
                      label="After Works"
                    />
                  </RadioGroup>
                </FormControl>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {formData.registrationPeriod === "Before Works" ? (
        // <BeforeWorks />
        <Card sx={{ marginBottom: "30px" }}>
          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography variant="h5">
                  Rooms disposal (Before works)
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <FormControl>
                    {/* <FormLabel id="demo-radio-buttons-group-label">
                    Rooms disposal (Before works)
                  </FormLabel> */}
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      //   defaultValue="Before Works"
                      name="radio-buttons-group"
                      value={formData.roomDisposalDependingBeforeWorks}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          roomDisposalDependingBeforeWorks: e.target.value,
                        })
                      }
                    >
                      <FormControlLabel
                        value="Stacked Rooms"
                        control={<Radio />}
                        label="Stacked Rooms"
                      />
                      <FormControlLabel
                        value="Side By Side Rooms"
                        control={<Radio />}
                        label="Side By Side Rooms"
                      />
                    </RadioGroup>
                  </FormControl>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ) : null}
      {formData.registrationPeriod === "After Works" ? (
        // <AfterWorks />
        <Card sx={{ marginBottom: "30px" }}>
          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography variant="h5">
                  Rooms disposal (After works)
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <FormControl>
                    {/* <FormLabel id="demo-radio-buttons-group-label">
                    Rooms disposal (Before works)
                  </FormLabel> */}
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      //   defaultValue="Before Works"
                      name="radio-buttons-group"
                      value={formData.roomDisposalDependingAfterWorks}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          roomDisposalDependingAfterWorks: e.target.value,
                        })
                      }
                    >
                      <FormControlLabel
                        value="Stacked Rooms"
                        control={<Radio />}
                        label="Stacked Rooms"
                      />
                      <FormControlLabel
                        value="Side By Side Rooms"
                        control={<Radio />}
                        label="Side By Side Rooms"
                      />
                    </RadioGroup>
                  </FormControl>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ) : null}
      {/* {formData.registrationPeriod === "Before Works" &&
      formData.roomDisposalDependingBeforeWorks === "Stacked Rooms" ? (
        <BstkHorizontalWall formData={formData} setFormData={setFormData} />
      ) : null}
      {formData.registrationPeriod === "Before Works" &&
      formData.roomDisposalDependingBeforeWorks === "Side By Side Rooms"
        ? "lol 1"
        : null}
      {formData.registrationPeriod === "After Works" &&
      formData.roomDisposalDependingBeforeWorks === "Stacked Rooms"
        ? "lol 2"
        : null}
      {formData.registrationPeriod === "After Works" &&
      formData.roomDisposalDependingBeforeWorks === "Side By Side Rooms"
        ? "lol 3"
        : null} */}
      {formData.registrationPeriod === "Before Works" &&
        formData.roomDisposalDependingBeforeWorks === "Stacked Rooms" && (
          <>
            <BstkHorizontalWall formData={formData} setFormData={setFormData} />
            <BstkStackedRoom1 formData={formData} setFormData={setFormData} />
            <BstkStackedRoom2 formData={formData} setFormData={setFormData} />
          </>
        )}

      {formData.registrationPeriod === "Before Works" &&
        formData.roomDisposalDependingBeforeWorks === "Side By Side Rooms" && (
          <>
            <BsbsVerticalWall formData={formData} setFormData={setFormData} />
            <BsbsSideRoom1 formData={formData} setFormData={setFormData} />
            <BsbsSideRoom2 formData={formData} setFormData={setFormData} />
          </>
        )}

      {formData.registrationPeriod === "After Works" &&
        formData.roomDisposalDependingAfterWorks === "Stacked Rooms" && (
          <>
            <AstkHorizontalWall formData={formData} setFormData={setFormData} />
            <AstkStackedRoom1 formData={formData} setFormData={setFormData} />
            <AstkStackedRoom2 formData={formData} setFormData={setFormData} />
          </>
        )}

      {formData.registrationPeriod === "After Works" &&
        formData.roomDisposalDependingAfterWorks === "Side By Side Rooms" && (
          <>
            <AsbsVerticalWall formData={formData} setFormData={setFormData} />
            <AsbsSideRoom1 formData={formData} setFormData={setFormData} />
            <AsbsSideRoom2 formData={formData} setFormData={setFormData} />
          </>
        )}
      <Grid align="right">
        <Button
          disabled={
            formData.roomDisposalDependingBeforeWorks === "" &&
            formData.roomDisposalDependingAfterWorks === ""
          }
          variant="contained"
          size="large"
          type="submit"
        >
          Create
        </Button>
      </Grid>
      {/* ) : null} */}
    </form>
  );
}
